const ToastStyle = {
    position : "top-right",
    duration : 2000
}
export { ToastStyle }